import { doc, getDoc } from 'firebase/firestore'
import { db } from 'controllers/db'
import store from 'model/store'
import { SettingsT } from 'shared/types/model'
import { receiveSettings } from 'model/actions/settingsAC'
import _ from 'lodash'

export const fetchSettings = async () => {
  try {
    const ref = doc(db, 'appSettings', 'settings')
    const settingsSN = await getDoc(ref)
    const settings: SettingsT = settingsSN.data() as SettingsT
    if (!_.isEmpty(settings)) {
      store.dispatch(receiveSettings(settings))
      return settings
    } else {
      console.warn('fetchSettings error: settings are empty')
      return null
    }
  } catch (e) {
    console.log('fetch settings error', e)
    return null
  }
}
